import { Box, VStack, Grid, GridItem } from "@chakra-ui/react";
import { FC } from "react";
import { BlockContainer } from "src/atoms";
import { Widget } from "@typeform/embed-react";
import Renderer from "src/lib/renderer";
import { heading2, heading3 } from "src/lib/renderer/elements/headings";
import paragraph from "src/lib/renderer/elements/paragraph";
import { Element } from "@prismicio/react";

const BlockEmbedTypeform: FC<
  (
    | Gatsby.PageBlockEmbedTypeformFragment
    | Gatsby.PageLandingBlockEmbedTypeformFragment
    | Gatsby.PageFragmentBlockEmbedTypeformFragment
  ) & { index: number }
> = ({ primary }) => {
  if (!primary) return null;

  const { content, typeform_id } = primary;


  if (!typeform_id) {
    return null;
  }

  // Prismic often returns an empty paragraph when no content is provided
  const hasContent = !!(
    content?.raw &&
    Array.isArray(content.raw) &&
    content.raw.some((block: any) => block.text && block.text.trim().length > 0)
  );

  return (
    <BlockContainer paddingY={{ base: "space-40", md: "space-64" }}>
      <VStack
        w="full"
        spacing="space-32"
        alignItems="center"
      >
        {hasContent ? (
          <Box w="full" textAlign="center">
            <Renderer
              overrides={{
                [Element.heading2]: (args) => heading2({ ...args, overrideProps: { textAlign: "center" } }),
                [Element.heading3]: (args) => heading3({ ...args, overrideProps: { textAlign: "center" } }),
                [Element.paragraph]: (args) =>
                  paragraph({
                    ...args,
                    overrideProps: {
                      textColor: "grey-1",
                      textAlign: "center"
                    },
                  }),
              }}
              field={content}
            />
          </Box>
        ) : null}
        <Box
          minHeight="500px"
          w="full"
          bg="white"
          borderRadius="intermediate"
          overflow="hidden"
          boxShadow="card"
        >
          <Widget
            id={typeform_id}
            style={{ width: "100%", height: "500px", border: "none" }}
            className="my-form"
          />
        </Box>
      </VStack>
    </BlockContainer>
  );
};

export default BlockEmbedTypeform;
